// extracted by mini-css-extract-plugin
export default {"services":"services_services__9Ox3f","container":"services_container__5FHhG"};